module.exports = __webpack_public_path__ + "img/block1.efc11fb4.png";